import { Modal } from "antd";
import { useState } from 'react';

import i18next from "i18next";

import { EdrService } from "../../service/cartoService";


//url
//http://localhost:7001/vica/api/v1/edr/foto/001



const ModalUpload = ({ open, codedar, action, fotos, setFotos }) => {

    //Este estado almacena las fotos seleccionadas que se van a subir
    const [listaFotos, setListaFotos] = useState([]);

    /**
     * Esta funcion realiza la peticion POST para subir las fotos.
     * También se devuelve como respuesta el nombre de la foto que se añade al array de fotos visualizadas.
     * 
     * @returns 
     */
    const handleUploadClick = async() => {
        if (!listaFotos) {
            return;
        }
        
        let copyFotos = [...fotos]

        for (let index = 0; index < listaFotos.length; index++) {
            const data = new FormData();
            const element = listaFotos[index];
            data.append(`file`, element);
            await EdrService.uploadEdarFoto(codedar, data)
                .then((data) => copyFotos.push(data))
                .catch((err) => console.error('error',err));
        }
        copyFotos.sort()
        setFotos(copyFotos)
    };

    /**
     * Esta función añade las fotos seleccionadas.
     * 
     * @param {*} e 
     */
    const handleFotoChange = (e) => {
        if (e.target.files) {
            setListaFotos(e.target.files);
        }
    };

    return (
        <Modal
            title={i18next.t('common.tools.edit.upload-img')} style={{ float: "right", marginRight: "4%" }}
            open={open}
            onOk={() => { action(false); handleUploadClick() }}
            onCancel={() => { action(false); setListaFotos([])}}
        >
            <div>
                <input 
                type="file" 
                onChange={handleFotoChange}
                accept=".jpg, .jpeg, .png"
                multiple />
            </div>
        </Modal>
    );
}

export default ModalUpload;